module.exports = __webpack_public_path__ + "img/guide03.4e22c213.png";